import imageCompression from 'browser-image-compression'

export const compressImage = async (
  file: File,
  maxSizeMB: number,
  maxWidthOrHeight: number
) => {
  return await imageCompression(file, {
    maxSizeMB,
    maxWidthOrHeight,
    useWebWorker: true,
    libURL: `${process.env.VUE_APP_PUBLIC_URL}/browser-image-compression/browser-image-compression.js`,
  })
}
